import { useNavigate, useLocation } from "react-router-dom";

const TABS = [
  { to: "/", label: "AI 看盘", off: "ri-dashboard-2-line", on: "ri-dashboard-2-fill" },
  { to: "/research", label: "研报", off: "ri-file-list-3-line", on: "ri-file-list-3-fill" },
  { to: "/ai-trader", label: "AI助手", off: "ri-robot-2-line", on: "ri-robot-2-fill" },
  { to: "/ai-strategy", label: "策略", off: "ri-function-line", on: "ri-function-fill" },
  { to: "/profile", label: "我的", off: "ri-user-3-line", on: "ri-user-3-fill" },
];

export default function BottomTabBar({ className = "" }: { className?: string }) {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const match = (p: string) => p === "/" ? pathname === "/" : pathname.startsWith(p);

  return (
    <div className={`fixed bottom-0 left-0 w-full z-50 bg-white/95 backdrop-blur-xl border-t border-background-200/60 pb-6 ${className}`}>
      <div className="flex items-stretch w-full" style={{ height: 56 }}>
        {TABS.map((t) => {
          const active = match(t.to);
          const isAi = t.to === "/ai-trader";

          return (
            <button key={t.to} onClick={() => nav(t.to)}
              className="flex-1 flex flex-col items-center justify-center cursor-pointer relative"
            >
              {isAi ? (
                <div className="flex flex-col items-center" style={{ marginBottom: 6 }}>
                  <div className="w-14 h-14 rounded-full flex items-center justify-center shadow-lg"
                    style={{
                      background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
                      boxShadow: active ? "0 4px 20px rgba(99,102,241,0.45)" : "0 4px 15px rgba(99,102,241,0.3)",
                    }}>
                    <i className="ri-robot-2-fill text-white text-2xl" />
                    {active && <span className="absolute -top-0.5 -right-0.5 w-3 h-3 rounded-full bg-green-400 border-2 border-white animate-pulse" />}
                  </div>
                  <span className={`text-[9px] whitespace-nowrap font-medium ${active ? "text-indigo-500" : "text-foreground-400"}`}>AI助手</span>
                </div>
              ) : (
                <>
                  <i className={`${active ? t.on : t.off} text-xl ${active ? "text-primary-500" : "text-foreground-400"}`} />
                  <span className={`text-[10px] whitespace-nowrap leading-none ${active ? "text-primary-500 font-semibold" : "text-foreground-400"}`}>{t.label}</span>
                  {active && <div className="absolute bottom-0 w-5 h-[3px] rounded-full bg-primary-500" />}
                </>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
